<template>
    <div class="modal fade" id="vuePaymentDeclinedModal" tabindex="-1 " role="dialog " aria-labelledby="vuePaymentDeclinedLabel">
        <div class="modal-dialog" role="document" v-cloak>
            <div class="modal-content">
                <div class="modal-header">
                    <button v-on:click="submitData" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true"></span>
                    </button>
                    <h2 class="modal-title">Payment Declined</h2>
                </div>
                <div class="modal-body">
                    <p class="text-center">{{ payload.declinedMessage || '' }}</p>
                    <div class="btn-wrap text-center">
                        <a class="btn btn-danger" v-on:click="submitData">Ok</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/jsx">
    import { Event } from '../../../../../assets/js/components/frontend/event.vue'
    export default {
        props: {
            onSubmit: {
                type: String,
                required: false,
                default: function () {
                    return 'onPaymentDeclinedPopupSubmit';
                }
            }
        },
        data: function () {
            return this.getDefaultData();
        },
        created: function () {
            Event.$on('paymentDeclinedPopupInvokeModal', this.onPopupInvokeModal);
        },
        beforeDestroy: function () {
            Event.$off('paymentDeclinedPopupInvokeModal', this.onPopupInvokeModal);
        },
        methods: {
            getDefaultData: function () {
                return {
                    onSubmitEvent: this.onSubmit,
                    payload: {
                        declinedMessage: ''
                    }
                }
            },
            onPopupInvokeModal: function (payload) {
                this.payload = Object.assign({}, this.payload, payload);
                $('#vuePaymentDeclinedModal').modal('show');
            },
            reset: function() {
                Object.assign(this.$data, this.getDefaultData());
            },
            submitData: function () {
                $('#vuePaymentDeclinedModal').modal('hide');
                Event.$emit(this.onSubmitEvent, this.payload);
                this.reset();
            }
        }
    };
</script>



// WEBPACK FOOTER //
// payment-declined.vue?f4e11c78